module.exports = __webpack_public_path__ + "03_medium_gold.8832e0ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_medium_gold.png
// module id = 2lK8
// module chunks = 0